import React from 'react';
import Plans from '../component/plan/Plans';
import ComponenetHeader from '../component/common/ComponenetHeader';
import planIcon1 from '../assets/plan_icon1.webp';
import planIcon2 from '../assets/plan_icon2.webp';
import planIcon3 from '../assets/plan_icon3.webp';
import pricingIcon from '../assets/pricing-work.svg';
import { Helmet } from 'react-helmet';

const PlanPage = () => {
  return (
    <>
      {/*  <ComponenetHeader
        name={'Plans'}
      /> */}

      <Helmet>
        <link rel="canonical" href="/plans" />
        <title>Smart Trailer Repair Service Plans – Affordable. Fast. Easy</title>
        <meta name="keywords" content="trailer repair service, trailer repairs,truck service near me,trailer repair near me,Reefer Repair,truck and trailer repair shop near me, heavy duty truck repair, trailer repair shops"/>
        <meta name="description" content="Don’t let trailer issues ruin your route. Our smart trailer repair service plans offer unbeatable value, 24/7 support, and fast response. Start your plan today!"/>
        <meta property="og:title" content="Smart Trailer Repair Service Plans – Affordable. Fast. Easy" />
        <meta property="og:description" content="Don’t let trailer issues ruin your route. Our smart trailer repair service plans offer unbeatable value, 24/7 support, and fast response. Start your plan today!"/>
      </Helmet>

      <section className='new_plan-section'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-10'>
              <div className='plan_new_content'>
                <div className='pricing_icon'>
                 <img src={pricingIcon} className='img-fluid' alt='Pricing'/>
                </div>
                <h1>How does Mechanic Hunt’s pricing work?</h1>
                <p>Mechanic Hunt offers a flexible, pay-as-you-go pricing structure designed to fit
                  the needs of your business. You’re only charged for the specific services you choose
                  to provide and the time you actively use the platform—without any long-term commitments
                  or confusing agreements.</p>
              </div>
              <div className='plan_new_highlight shadow'>
                <p>Much like utilities such as water or electricity, billing is based entirely on real usage.
                  There are no hidden costs, extra fees, or penalties if you decide to stop using our system.
                  Discover how partnering with Mechanic Hunt can simplify your operational expenses and
                  support your business growth. Reach out to us for a personalized pricing quote.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Plans />

    </>
  );
};

export default PlanPage;
